"use client"
import { EmptyMessage } from "@tapcart/mobile-components"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useActions } from "@tapcart/app-studio-sdk"

export default function NotFound() {
  const actions = useActions()

  return (
    <div className="flex items-center justify-center h-screen">
      <EmptyMessage
        iconName="mood-sad"
        title="Not Found"
        description="The requested page could not be found."
        openScreen={actions.openScreen}
        usePathname={usePathname}
        useRouter={useRouter}
        useSearchParams={useSearchParams}
        buttonLabel="Keep Shopping"
      />
    </div>
  )
}
